import React from 'react';

const SIE_URL =
  'https://zn1qm6dvkztflmps3-johndeerefinancialeu.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_1Qm6dvkztFlmPS3';
const SCRIPT_ID = 'qualtrics-loader';

const Qualtrics = () => {
  React.useEffect(() => {
    if (document.getElementById(SCRIPT_ID)) {
      return;
    }
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.type = 'text/javascript';
    script.src = SIE_URL;
    document.body.appendChild(script);
  }, []);

  return null;
};

export default Qualtrics;
